// AOS.init();
// https://michalsnik.github.io/aos/
//<div data-aos="fade-up" data-aos-offset="0" data-aos-easing="ease-in-out" data-aos-duration="800">

import { gsap } from "gsap";
import $ from 'jquery';
import ScrollTrigger from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

// home banner
if($('.component.logos').length) {
    let items = $('.component.logos .item')
    gsap.set(items, {   
        opacity:0.0,
        scale: 0.0,
    });
    gsap.to(items, {
        opacity: 1.0,
        scale: 1.0,
        duration: 1.0,
        ease: 'elastic(0.65)',
        stagger: { 
            each: 0.2
        },
        scrollTrigger: {
            trigger: $(".component.logos"),
            start: "bottom bottom"
        }
    })
}

$('.dropdowns_with_images .left .item').first().find('.expandable').slideDown(400)
$('.dropdowns_with_images .left .item h3').on('click', function(e){
    const item = $(this).closest('.item')
    $('.dropdowns_with_images .left .item.active .expandable').stop().slideUp(400)
    $('.dropdowns_with_images .left .item.active').removeClass('active')
    item.addClass('active')
    item.find('.expandable').stop().slideDown(400);

    const id = item.attr('data-id')
    const image = $('.dropdowns_with_images .right .image[data-id=' + id + ']')
    const notImage = $('.dropdowns_with_images .right .image').not('[data-id=' + id + ']')

    // add gsap!
    gsap.set(image, {   
        opacity:0.0,
        scale: 0.0,
        zIndex: 2
    });
    gsap.to(image, {
        opacity: 1,
        scale: 1.0,
        duration: 0.75,
        ease: 'elastic(0.35)',
    })

    gsap.set(notImage, {
        zIndex: 1
    })
    gsap.to(notImage, {
        opacity: 0,
        scale: 0.0,
        duration: 0.3,
    })
})
